import OktyabriskiyRayon from './coordinates/Barnaul/Oktyabriskiy.json';
import IndustrialiniyRayon from './coordinates/Barnaul/Industrialiniy.json';
import CentraliniyRayon from './coordinates/Barnaul/Centraliniy.json';
import LeninskiyRayon from './coordinates/Barnaul/Leninskiy.json';
import ZheleznodorozhniyRayon from './coordinates/Barnaul/Zheleznodorozhniy.json';
import Novosilikatniy from './coordinates/Barnaul/exclude/Novosilikatniy.json';
import Kueta from './coordinates/Barnaul/exclude/Kueta.json';
import Belimesevo from './coordinates/Barnaul/exclude/Belimesevo.json';
import BorzovayaZaimka from './coordinates/Barnaul/exclude/Borzovaya Zaimka.json';
import ZheleznodorozhnayaKazarma242 from './coordinates/Barnaul/exclude/Zheleznodorozhnaya Kazarma 242 km.json';
import ZheleznodorozhnayaKazarma250 from './coordinates/Barnaul/exclude/Zheleznodorozhnaya Kazarma 250 km.json';
import ZheleznodorozhnayaKazarma253 from './coordinates/Barnaul/exclude/Zheleznodorozhnaya Kazarma 253 km.json';
import Konyuhi from './coordinates/Barnaul/exclude/Konyuhi.json';
import Lebyazhie from './coordinates/Barnaul/exclude/Lebyazhie.json';
import Mohnatushka from './coordinates/Barnaul/exclude/Mohnatushka.json';
import Plodopitomnik from './coordinates/Barnaul/exclude/Plodopitomnik.json';
import Polzunovo from './coordinates/Barnaul/exclude/Polzunovo.json';
import Sadovodov from './coordinates/Barnaul/exclude/Sadovodov.json';
import Centraliniy from './coordinates/Barnaul/exclude/Centraliniy.json';
import Chernick from './coordinates/Barnaul/exclude/Chernick.json';
import Yuzhniy from './coordinates/Barnaul/exclude/Yuzhniy.json';
import Yagodnoe from './coordinates/Barnaul/exclude/Yagodnoe.json';
import NauchniyGorodok from './coordinates/Barnaul/exclude/Nauchniy gorodok.json';
import KazennayaZaimka from './coordinates/Barnaul/exclude/Kazennaya zaimka.json';
import Berezovka from './coordinates/Barnaul/exclude/Berezovka.json';
import Goniba from './coordinates/Barnaul/exclude/Goniba.json';
import Novomihaylovka from './coordinates/Barnaul/exclude/Novomihaylovka.json';

export default {
    regionCode: 'barnaul',
    serviceAreas: [
        {
            id: 'barnaul-1',
            include: [
                {
                    name: 'Октябрьский район',
                    type: 'polygon',
                    coordinates: OktyabriskiyRayon,
                },
                {
                    name: 'Индустриальный район',
                    type: 'polygon',
                    coordinates: IndustrialiniyRayon,
                },
                {
                    name: 'Центральный район',
                    type: 'polygon',
                    coordinates: CentraliniyRayon,
                },
                {
                    name: 'Ленинский район',
                    type: 'polygon',
                    coordinates: LeninskiyRayon,
                },
                {
                    name: 'Железнодорожный район',
                    type: 'polygon',
                    coordinates: ZheleznodorozhniyRayon,
                },
            ],
            exclude: [
                {
                    name: 'Новосиликатный',
                    type: 'polygon',
                    coordinates: Novosilikatniy,
                },
                {
                    name: 'Куета',
                    type: 'polygon',
                    coordinates: Kueta,
                },
                {
                    name: 'Бельмесёво',
                    type: 'polygon',
                    coordinates: Belimesevo,
                },
                {
                    name: 'Борзовая Заимка',
                    type: 'polygon',
                    coordinates: BorzovayaZaimka,
                },
                {
                    name: 'Железнодорожная Казарма 242 км',
                    type: 'polygon',
                    coordinates: ZheleznodorozhnayaKazarma242,
                },
                {
                    name: 'Железнодорожная Казарма 250 км',
                    type: 'polygon',
                    coordinates: ZheleznodorozhnayaKazarma250,
                },
                {
                    name: 'Железнодорожная Казарма 253 км',
                    type: 'polygon',
                    coordinates: ZheleznodorozhnayaKazarma253,
                },
                {
                    name: 'Конюхи',
                    type: 'polygon',
                    coordinates: Konyuhi,
                },
                {
                    name: 'Лебяжье',
                    type: 'polygon',
                    coordinates: Lebyazhie,
                },
                {
                    name: 'Мохнатушка',
                    type: 'polygon',
                    coordinates: Mohnatushka,
                },
                {
                    name: 'Плодопитомник',
                    type: 'polygon',
                    coordinates: Plodopitomnik,
                },
                {
                    name: 'Ползуново',
                    type: 'polygon',
                    coordinates: Polzunovo,
                },
                {
                    name: 'Садоводов',
                    type: 'polygon',
                    coordinates: Sadovodov,
                },
                {
                    name: 'Центральный',
                    type: 'polygon',
                    coordinates: Centraliniy,
                },
                {
                    name: 'Черницк',
                    type: 'polygon',
                    coordinates: Chernick,
                },
                {
                    name: 'Южный',
                    type: 'polygon',
                    coordinates: Yuzhniy,
                },
                {
                    name: 'Ягодное',
                    type: 'polygon',
                    coordinates: Yagodnoe,
                },
                {
                    name: 'Научный городок',
                    type: 'polygon',
                    coordinates: NauchniyGorodok,
                },
                {
                    name: 'Казённая заимка',
                    type: 'polygon',
                    coordinates: KazennayaZaimka,
                },
                {
                    name: 'Берёзовка',
                    type: 'polygon',
                    coordinates: Berezovka,
                },
                {
                    name: 'Гоньба',
                    type: 'polygon',
                    coordinates: Goniba,
                },
                {
                    name: 'Новомихайловка',
                    type: 'polygon',
                    coordinates: Novomihaylovka,
                },
            ],
        },
    ],
};

